import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const hasAuthCookie = () => {
  return !!Cookies.getJSON('cw_d_session_info');
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (ssoConversationId) {
      return `${accountPath}/conversations/${ssoConversationId}`; // d99d removed frontendURL
    }

    if (getSpecificRedirectUrl()) return getSpecificRedirectUrl(accountPath.split("/").pop()) // d99d

    return (`${accountPath}/dashboard`); // d99d removed frontendURL
  }
  return '/'; //DEFAULT_REDIRECT_URL; // d99d commented out
};

// d99d
export const getSpecificRedirectUrl = accountId => {
  let uri = window.location.search.substring(1);
  let params = new URLSearchParams(uri);
  const contact_phone = params.get('to_conversation_with_phone');
  const contact_email = params.get('to_conversation_with_email');
  const contact_name = params.get('contact_name');
  const conversationId = params.get('to_conversation_id');
  const inboxId = params.get('to_inbox_id');

  // 1. Specific existing conversation - highest priority
  if (conversationId) {
    return `/app/accounts/${accountId}/s/conversations/${conversationId}`;
  }

  // 2. WhatsApp/phone-based contact conversation
  if (contact_phone) {
    const query = new URLSearchParams();
    if (contact_name) query.set('contact_name', contact_name);
    if (inboxId) query.set('inbox_id', inboxId);
    const qs = query.toString();
    return `accounts/${accountId}/s/phone_contacts/${contact_phone.trim()}/conversations${
      qs ? `?${qs}` : ''
    }`;
  }

  // 3. Email composer flow - requires inbox
  if (contact_email && inboxId) {
    const query = new URLSearchParams();
    query.set('inbox_id', inboxId);
    if (contact_name) query.set('contact_name', contact_name);
    const qs = query.toString();
    return `accounts/${accountId}/s/email_contacts/${encodeURIComponent(
      contact_email.trim()
    )}/conversations${qs ? `?${qs}` : ''}`;
  }

  return null;
};
// .
